import { create } from 'zustand';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

// 월세액
export const initRentMPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: '', //입력데이터 sequence
  hs_nm: '', // 임대인 성명
  hs_type: '', // "주택유형 단독주택 ‘1’, 다가구 ‘2’, 다세대주택 ‘3’, 연립주택 ‘4’, 아파트 ‘5’, 오피스텔 ‘6’, 고시원 ‘7’, 기타 ‘8’"
  hs_res_id: '', // 주민등록번호
  hs_area: '', // 주택면적
  hs_address: '', // 임대차계약서상 주소지
  hs_start_date: '', // 임대차계약 시작일
  hs_end_date: '', // 임대차계약 종료일
  year_amt: 0, // 연 납입액(근무기간중)
  amt: 0, // 월세 월 납입액
  is_htx_pdf: 'Y', //국세청사용여부
  question_status: '', //설문상태
  etc_type: '', //"자료코드 G0000: 일반, G0037: 공공임대주택 월세액, G0042 : 신용카드 월세액"
};

/**
  월세액
**/
export const rentMDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initRentMPayload,
  payload: initRentMPayload,
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
